import { Option } from 'components/Select/types';

export const CONTACT_RELATION_OPTIONS = [
  { value: 'Mother', label: 'Mother' },
  { value: 'Father', label: 'Father' },
  { value: 'Spouse / Significant Other', label: 'Spouse / Significant Other' },
  { value: 'Friend', label: 'Friend' },
  { value: 'Other', label: 'Other' },
] as Option[];
